import { useRef } from "react";

// How long the camera has to be off a refused code before that code is tried again.
const QUIET_MS = 4000;

/**
 * Stops a scan page re-sending a code it was just refused.
 *
 * After a refusal the scan pages show the camera again, and with the phone still on the
 * same unit it read the code straight back and re-sent it: 39 refused requests in about
 * 5 s, and a toast for each (N29). A refused serial is ignored while the camera stays on
 * it; once it has been out of view for QUIET_MS it is tried again, once, so a refusal that
 * no longer applies goes through. A different code is never held back.
 */
export function useRefusedScan() {
  const refused = useRef(null); // { serial, lastSeen }

  const refuse = (serial) => {
    if (serial) refused.current = { serial, lastSeen: Date.now() };
  };

  // Each sighting of the refused code keeps it ignored for another QUIET_MS.
  const ignore = (serial) => {
    const r = refused.current;
    if (!r || r.serial !== serial) return false;
    const now = Date.now();
    if (now - r.lastSeen > QUIET_MS) {
      refused.current = null;
      return false;
    }
    r.lastSeen = now;
    return true;
  };

  return { refuse, ignore };
}
